export function getFooterColumnsWidths(columnWidths, visibleBusinessDetails, visibleSocialIcons, visibleSiteTitle) {
    const socialColumnWidth = visibleSocialIcons && visibleBusinessDetails
        ? columnWidths[1]
        : columnWidths[0];
    const businessColumnWidth = visibleBusinessDetails && columnWidths[0];
    const titleWidth = visibleSiteTitle && columnWidths[columnWidths.length - 1];
    return {
        socialColumnWidth: (socialColumnWidth && `${socialColumnWidth}%`) || undefined,
        businessColumnWidth: (businessColumnWidth && `${businessColumnWidth}%`) || undefined,
        titleWidth: (titleWidth && `${titleWidth}%`) || undefined,
    };
}
//# sourceMappingURL=footer-utils.js.map